<template>
  <div class="sorders">
    <!-- 실제 주문만 보여 준다. 결제가 완료된 건만 내려온다. -->
    <SellerLiveOrders />
  </div>
</template>

<script setup lang="ts">
import SellerLiveOrders from '@/components/seller/SellerLiveOrders.vue'
</script>

<style lang="scss" src="./SellerOrdersPage.scss"></style>
